import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppVideoTipsPage } from './app-video-tips';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppVideoTipsPage,
  ],
  imports: [
    IonicPageModule.forChild(AppVideoTipsPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppVideoTipsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-video-tips/app-video-tips.module.ts